// extracted by mini-css-extract-plugin
export default {"orderProgressBar":"OrderProgressBar_orderProgressBar__QAvc3","bar":"OrderProgressBar_bar__Wdgdn","progressInfo":"OrderProgressBar_progressInfo__DC3Mi"};